import { useAuthContext } from "@features/auth/contexts/AuthContext";
import {
	COPILOT_URL,
	GREETING_MESSAGE,
	RedeemCopilotChat,
	RedeemCopilotContext,
	WARNING_MESSAGE,
} from "@features/redeem-copilot";
import { COPILOT_INSTRUCTIONS } from "@features/redeem-copilot/instructions";
import { useAppStore } from "@hooks/useAppStore";
import { useMemo } from "react";
import RedeemCodeRouter from "../RedeemCodeRouter";

const RedeemCodeCopilotWrapper = () => {
	const tenantReadableName = useAppStore((store) => store.tenant.name);
	const appName = useAppStore((store) => store.app.name);
	const appSupportEmail = useAppStore((store) => store.supportEmail);
	const { viewerId } = useAuthContext();

	const { newUserInfo } = useAuthContext();

	const assistantTitle = `${tenantReadableName} Support Assistant`;

	const allDetailsLoaded =
		viewerId &&
		newUserInfo?.email &&
		appName &&
		appSupportEmail &&
		tenantReadableName;

	const initialChatState = useMemo(() => {
		return {
			assistantTitle,
			appName,
			appSupportEmail,
			appTeamName: tenantReadableName,
			userId: viewerId,
			username: newUserInfo?.name,
			userEmail: newUserInfo?.email,
		};
	}, [
		assistantTitle,
		appName,
		appSupportEmail,
		tenantReadableName,
		viewerId,
		newUserInfo,
	]);

	return (
		<RedeemCopilotContext
			runtimeUrl={COPILOT_URL}
			initialChatState={initialChatState}
			instructions={COPILOT_INSTRUCTIONS}
			enableAnalytics
		>
			{allDetailsLoaded && (
				<RedeemCopilotChat
					greetingMessage={GREETING_MESSAGE}
					warningMessage={WARNING_MESSAGE}
				/>
			)}
			<RedeemCodeRouter />
		</RedeemCopilotContext>
	);
};

export default RedeemCodeCopilotWrapper;
